import { render, staticRenderFns } from "./proposal-modal-image.vue?vue&type=template&id=5a52b8e4"
import script from "./proposal-modal-image.vue?vue&type=script&lang=js"
export * from "./proposal-modal-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports